import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatCheckbox} from '@angular/material/checkbox'
import {
  LogoComponent, SpbAccessibleLinkDirective,
  ToggleButtonComponent
} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {SavingsAccountService} from '../../services/savings-account.service'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatCheckbox, LogoComponent, ToggleButtonComponent, SpbAccessibleLinkDirective, MatButton]
})
export class HeaderComponent {
  public testMode = environment.testMode
  public readonly savingsAccountService = inject(SavingsAccountService)

}
